import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import FormModel from '../../../models/Form';
import { modelOf } from '../../../prop-types';
import FormFieldId from '../../../types/FormFieldId';
import { labels } from '../../../util/formLabels';
import FormGroupField from '../../form/FormGroupField';

const formName = 'CampaignCodeForm';

const CampaignCodeForm = ({ campaignCodeForm, disabled, onCodeUpdate }) => {
  const campaignCodeField = campaignCodeForm.getField(
    FormFieldId.CAMPAIGN_CODE
  );

  if (!campaignCodeField) {
    return null;
  }

  const handleForm = (e) => {
    e.preventDefault();
    campaignCodeForm.validateField(FormFieldId.CAMPAIGN_CODE);
    if (campaignCodeForm.valid) {
      onCodeUpdate(e);
    }
  };

  return (
    <div className="CampaignCodeForm">
      <div className="CampaignCodeForm__fields">
        <div className="CampaignCodeForm__field">
          <FormGroupField
            field={campaignCodeField}
            fieldName={FormFieldId.CAMPAIGN_CODE}
            formName={formName}
            floatingLabel
            label={labels.campaignCode}
          />
        </div>
        <Button
          className="CampaignCodeForm__submit"
          color="secondary"
          disabled={disabled}
          onClick={handleForm}
        >
          <FormattedMessage
            id="campaign.activateCode"
            defaultMessage="Activate"
          />
        </Button>
      </div>
    </div>
  );
};

CampaignCodeForm.propTypes = {
  campaignCodeForm: modelOf(FormModel).isRequired,
  disabled: PropTypes.bool.isRequired,
  onCodeUpdate: PropTypes.func.isRequired,
};

export default observer(CampaignCodeForm);
